import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  LucideCalendar,
  LucideClipboard,
  LucideKeyRound,
  LucideLayoutDashboard,
  LucideLock,
  LucideMonitorPlay,
  LucidePill,
  LucidePresentation,
  LucideSend,
  LucideShield,
  LucideStore,
  LucideUserRoundCog,
  LucideUsers,
  LucideWorkflow,
  LucideWrench,
} from '@lucide/angular';
import { environment } from 'src/environments/environment';
import { MaintenanceWindowComponent } from 'src/shared/components/maintenance-window/maintenance-window.component';
import { initTranslations } from 'src/shared/translate/custom.translate.loader';
import { MenuComponent } from './shared/components/menu/menu.component';
import { PortalHeader, PortalHeaderItemType } from './shared/components/menu/menu.type';

@Component({
  selector: 'app-root',
  templateUrl: './portal.component.html',
  styles: `
    * {
      font-family: 'Inter', sans-serif;
    }
  `,
  imports: [RouterOutlet, MenuComponent, MaintenanceWindowComponent],
})
export class PortalComponent {
  menu: PortalHeader = {
    hiddenpaths: [
      '/login',
      '/register',
      '/unauthorised',
      '/forgottenpassword',
      '/notfound',
      '/checkaccess',
      '/onboarding',
      '/maintenance-window',
    ],
    hiddenpagewrappers: [
      'algorithm-builder',
      'trials',
      'prescriptions',
      'checkaccess',
      'onboarding',
      'login',
      'register',
      'forgottenpassword',
      'unauthorised',
      'notfound',
    ],
    logo: 'https://firebasestorage.googleapis.com/v0/b/v,tai-e3e47.appspot.com/o/joii%2Fvetaiicon.png?alt=media&token=3e3942bd-4fd8-48c6-9249-096d5b35bef9',
    accountpath: '/account/logout',
    showLanguageSwitcher: true,
    items: [
      {
        id: 'token-copier',
        title: 'Auth',
        type: PortalHeaderItemType.TokenCopier,
        requiredroles: [],
        icon: LucideLock,
        dataautomationid: 'portal-sidebar-token-copier',
        hidden: false,
      },
      {
        id: '/dashboard',
        title: 'Dashboard',
        type: PortalHeaderItemType.Path,
        requiredroles: [],
        icon: LucideLayoutDashboard,
        dataautomationid: 'portal-sidebar-dashboard',
        hidden: false,
      },
      {
        id: '/scheduling',
        title: 'Scheduling',
        type: PortalHeaderItemType.Path,
        requiredroles: ['clinical_operations'],
        icon: LucideCalendar,
        dataautomationid: 'portal-sidebar-scheduling',
        hidden: false,
      },
      {
        id: '/symptomchecker',
        title: 'Algorithms',
        type: PortalHeaderItemType.Path,
        requiredroles: ['algorithm_developer'],
        icon: LucideWorkflow,
        dataautomationid: 'portal-sidebar-symptom-checker',
        hidden: false,
      },
      {
        id: '/security',
        title: 'Security',
        type: PortalHeaderItemType.Path,
        requiredroles: ['security'],
        icon: LucideShield,
        dataautomationid: 'portal-sidebar-security',
        hidden: false,
      },
      {
        id: '/demo',
        title: 'Demo',
        type: PortalHeaderItemType.Path,
        requiredroles: ['demo_admin'],
        icon: LucidePresentation,
        dataautomationid: 'portal-sidebar-demo',
        hidden: false,
      },
      {
        id: '/users',
        title: 'Users',
        type: PortalHeaderItemType.Path,
        requiredroles: ['user_admin'],
        icon: LucideUsers,
        dataautomationid: 'portal-sidebar-users',
        hidden: false,
      },
      {
        id: '/prescriptions',
        title: 'Prescriptions',
        type: PortalHeaderItemType.Path,
        requiredroles: ['prescription_admin'],
        icon: LucidePill,
        dataautomationid: 'portal-sidebar-prescriptions',
        hidden: false,
      },
      {
        id: '/entitlements',
        title: 'Entitlements',
        type: PortalHeaderItemType.Path,
        requiredroles: ['entitlements_admin'],
        icon: LucideKeyRound,
        dataautomationid: 'portal-sidebar-entitlements',
        hidden: false,
      },
      {
        id: '/shop',
        title: 'Shop',
        type: PortalHeaderItemType.Path,
        requiredroles: ['shop_admin'],
        icon: LucideStore,
        dataautomationid: 'portal-sidebar-shop',
        hidden: false,
      },
      {
        id: '/consultationConfig',
        title: 'Consults',
        type: PortalHeaderItemType.Path,
        requiredroles: ['clinical_admin'],
        icon: LucideSend,
        dataautomationid: 'portal-sidebar-consultation-config',
        hidden: false,
      },
      {
        id: '/customer-success-admin',
        title: 'CS Admin',
        type: PortalHeaderItemType.Path,
        requiredroles: ['customer_success_admin'],
        icon: LucideUserRoundCog,
        dataautomationid: 'portal-sidebar-cs-admin',
        hidden: false,
      },
      {
        id: '/trials',
        title: 'TMS',
        type: PortalHeaderItemType.Path,
        requiredroles: ['tms_operator', 'tms_administrator'],
        icon: LucideClipboard,
        dataautomationid: 'portal-sidebar-tms',
        hidden: !environment.activate_trials,
      },
      {
        id: '/joii-sessions',
        title: 'Joii Sessions',
        type: PortalHeaderItemType.Path,
        requiredroles: ['sandboxdeveloper'],
        icon: LucideMonitorPlay,
        dataautomationid: 'portal-sidebar-joii-sessions',
        hidden: false,
      },
      {
        id: '/maintenance',
        title: 'Maintenance',
        type: PortalHeaderItemType.Path,
        requiredroles: ['maintenance'],
        icon: LucideWrench,
        dataautomationid: 'portal-sidebar-maintenance',
        hidden: false,
      },
    ],
  };

  constructor() {
    // initialize ngx translations
    initTranslations();
  }
}
